module.exports = __webpack_public_path__ + "static/media/tram.13186a5b.svg";